import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import Cookies from 'js-cookie';

// API token süresi dolduğunda veya token bulunamadığında otomatik çıkış yaptırmak için global axios interceptor
const clearAuthAndRedirect = () => {
  window.isTokenExpired = true;
  localStorage.clear(); // Kullanıcı oturumlarını sıfırla
  sessionStorage.clear(); 
  Cookies.remove("user"); // AuthContainer'in tekrar logout atmasını önlemek için cookie'yi sil
  if (window.location.pathname !== '/') {
    window.location.href = '/'; // Login sayfasına yönlendir
  }
};

axios.interceptors.response.use(
  (response) => {
    // Başarılı (2xx) HTTP dönse bile kendi içindeki özel Message kısmını kontrol edelim
    if (response.data && response.data.Response && typeof response.data.Response.Message === 'string') {
      if (response.data.Response.Message.toLowerCase().includes('api token not found')) {
        clearAuthAndRedirect();
        return Promise.reject(new Error('API Token expired'));
      }
    }
    return response;
  },
  (error) => {
    // Çöken (401 vb) HTTP durumlarına karşı kontrol
    if (error.response && (error.response.status === 401)) {
      clearAuthAndRedirect();
    } else if (error.response && error.response.data && typeof error.response.data.Message === 'string' && error.response.data.Message.toLowerCase().includes('api token not found')) {
      clearAuthAndRedirect();
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
